export const requirementsPt = {
  resources: {
    createHelp: 'Criar formulario de ajuda',
    showIp: 'Exibir ip',
    showSystemRequirements: 'Exibir requisitos do systema',
    showSystemStatus: 'Exibir status do sistema'
  },

  components: {
    accordionBrowser: {
      title: 'Navegador',
      type: 'Tipo',
      version: 'Versão',
      tooltip: {
        incompatibleBrowserMessage:
          'Este navegador não é indicado e poderá afetar o desempenho durante seu uso. Indicamos que utilize um dos seguintes navegadores: Chrome, MS Edge, Firefox ou Safari.',
        incompatibleBrowserVersionMessage:
          'Atenção: O navegador não atende aos requisitos mínimos. Recomendamos o uso do Chome mais atualizado para melhor performance. '
      }
    },
    accordionOperationalSystem: {
      title: 'Sistema Operacional',
      type: 'Tipo',
      version: 'Versão',
      tooltip: {
        incompatibleSystemVersionMessage:
          'Atenção: A versão do sistema operacional não atende aos requisitos mínimos. Recomendamos o uso do WINDOWS na versão 8 ou superior para melhor performance.'
      }
    },
    accordionHardware: {
      title: 'Hardware',
      screenSize: 'Tamanho de tela',
      touch: 'Touch-screen',
      deviceType: 'Tipo de dispositivo',
      yes: 'Sim',
      no: 'Não',
      tooltip: {
        maxScreen:
          'Sua resolução é maior que a recomenda para uso desta aplicação. Recomendamos que utilize a resolução máxima de 1920x1080.'
      }
    },
    accordionNetworkConnection: {
      title: 'Conexão de Rede',
      ipAddress: 'Endereço de IP',
      internetSpeed: 'Velocidade de internet',
      unidentifiedIp: 'IP Não indentificado',
      tooltip: {
        ipError: 'Não foi possível identificar seu ip.',
        speedTestError: 'Não foi possível medir sua velocidade de internet'
      }
    },
    accordionAudio: {
      title: 'Teste de Reprodução de Áudio',
      audioTest: 'Teste a reprodução de áudio do seu dispositivo',
      questionAudio: 'Você consegue ouvir o áudio?',
      buttons: {
        yes: 'Sim',
        no: 'Não',
        executeTest: 'Execute um teste',
        testAgain: 'Teste novamente'
      }
    },
    accordionVideo: {
      title: 'Teste de reprodução de video',
      testVideo: 'Teste a reprodução de vídeo do seu dispositivo',
      questionVideo: 'Você consegue visualizar o vídeo?',
      buttons: {
        yes: 'Sim',
        no: 'Não',
        executeTest: 'Execute um teste',
        testAgain: 'Teste novamente'
      }
    },
    accordionServices: {
      title: 'Serviços Hub',
      service: 'Servidor',
      database: 'Banco de dados',
      accessible: 'Acessível',
      inaccessible: 'Inacessível'
    },
    helpForm: {
      institution: 'Instituição de ensino',
      name: 'Nome',
      email: 'E-mail',
      obs: 'Observações',
      helpTitle: 'Precisa de ajuda para corrigir falhas?',

      helpSubTitle:
        'Por favor, adicione suas informações de contato e clique em “enviar resultado” para enviar para o suporte.',
      buttons: {
        sendResults: 'Enviar resultado'
      },
      textDialog: {
        title: 'Resultados enviados com sucesso!',
        contentText:
          'Os resultados da verificação do sistema serão compartilhados com o educacional automaticamente.',
        acceptAction: {
          label: 'Fechar'
        }
      }
    }
  },
  pages: {
    details: {
      pageTitle: 'Verificador de requisitos do sistema',
      helpText:
        'Por favor, adicione suas informações de contato e clique em “enviar resultado” para enviar para o suporte.',
      helpSubTitle: 'Se preferir, clique em “copiar resultados” para envio por e-mail ou whatsapp.',
      login: 'Login',
      speedTestError: 'Velocidade de internet abaixa do limite sugerido ',
      errorMessage: 'Dado não encontrado',
      database: 'Banco de dados',
      resultPayload: {
        browser: 'Navegador',
        type: 'Tipo',
        version: 'Versão',
        operationalSystem: 'Sistema Operacional',
        hardware: 'Hardware',
        operationalSystemVersion: 'Versão do sistema operacional',
        screenSize: 'Tamanho de tela',
        touch: 'Touch-screen',
        deviceType: 'Tipo de dispositivo',
        networkConnection: 'Conexão de Rede',
        ipAddress: 'Endereço de IP',
        internetSpeed: 'Velocidade de internet',
        audio: 'Teste de reprodução de áudio',
        video: 'Teste de reprodução de video',
        service: 'Servidor',
        dataBase: 'Banco de dados',
        success: 'Sucesso',
        failure: 'Falha',
        noTest: 'não executado teste'
      },
      alert: {
        subTitle: 'Dados copiados com sucesso!'
      },
      buttons: {
        copyResult: 'Copiar resultados'
      }
    }
  }
}
